import React from 'react';

import { TOOLBARS } from '@atlaskit/editor-common/toolbar';
import type {
	EditorAppearance,
	OptionalPlugin,
	PublicPluginAPI,
} from '@atlaskit/editor-common/types';
import type { ToolbarPlugin } from '@atlaskit/editor-plugins/toolbar';
import type { EditorView } from '@atlaskit/editor-prosemirror/view';

import { isToolbar } from '../../../utils/toolbar';
import { ToolbarNext } from '../../Toolbar/Toolbar';

type ToolbarEditorPlugins = [OptionalPlugin<ToolbarPlugin>];

type CommentToolbarProps = {
	disabled?: boolean;
	editorAPI?: PublicPluginAPI<ToolbarEditorPlugins>;
	editorAppearance: EditorAppearance;
	editorView?: EditorView;
	popupsBoundariesElement?: HTMLElement;
	popupsMountPoint?: HTMLElement;
	popupsScrollableElement?: HTMLElement;
};

/**
 * Primary toolbar driven by components registered by `editor-plugin-toolbar`.
 */
export const CommentToolbar = ({
	editorAPI,
	editorView,
	editorAppearance,
	disabled,
	popupsBoundariesElement,
	popupsMountPoint,
	popupsScrollableElement,
}: CommentToolbarProps): React.JSX.Element | null => {
	const components = editorAPI?.toolbar?.actions.getComponents();
	const toolbar = components?.find((component) => component.key === TOOLBARS.PRIMARY_TOOLBAR);

	if (!components || !isToolbar(toolbar)) {
		return null;
	}

	return (
		<ToolbarNext
			toolbar={toolbar}
			components={components}
			editorView={editorView}
			editorAPI={editorAPI}
			editorAppearance={editorAppearance}
			isDisabled={disabled}
			popupsBoundariesElement={popupsBoundariesElement}
			popupsScrollableElement={popupsScrollableElement}
			popupsMountPoint={popupsMountPoint}
		/>
	);
};
